var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"modal-header\"\u003E\u003Cdiv class=\"modal-title\"\u003E \u003Ch3\u003E{{$ctrl.title}}\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body\"\u003E\u003Cp ng-if=\"!$ctrl.result\"\u003ETesting...\u003C\u002Fp\u003E\u003Cdiv class=\"white-space-pre-line\" ng-if=\"$ctrl.result\"\u003E{{$ctrl.result}} \u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer\"\u003E\u003Cbutton class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\"\u003EClose\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/component/device/firewall-test/index.pug
// module id = 455
// module chunks = 0